module.exports = __webpack_public_path__ + "static/media/advise-circle.d622d183.svg";